(function () {
    'use strict';
    var controllerId = 'getAlertsCtrl';
    angular
      .module('app.controllers')
      .controller(controllerId, getAlertsCtrl);
    
    getAlertsCtrl.$inject = ['common', 'datacontext', '$http', '$scope', '$sce', '$state', '$stateParams',
      '$translate', '$window', '$timeout', 'moment', '$rootScope', 'localStorageService'];
    
    function getAlertsCtrl(common, datacontext, $http, $scope, $sce, $state, $stateParams,
      $translate, $window, $timeout, moment, $rootScope, localStorageService) {
      
      let config = common.config;
      let vm = this;
      let $parent = $scope.$parent.$parent;
      $scope.trustAsHtml = $sce.trustAsHtml;
  
      var messages = ($parent != null && $parent.alertsToShow != null) ? $parent.alertsToShow : [];
    
      vm.dlgTitle = $translate.instant('views.alert.userMessage');
      vm.currentMessage = messages[0].Description.replaceAll(/\n/g, "<br>");;
      vm.btnCloseText = $translate.instant('views.alert.showNoMore');
  
      vm.currentMsgIndex = 0;
      vm.currentMsgNumber = 1;
      vm.msgCount = messages.length;
  
      vm.showPrevMessage = showPrevMessage;
      vm.showNextMessage = showNextMessage;
      vm.closeDialog = closeDialog;
  
      vm.isFirstMessageShown = true;
      vm.isLastMessageShown = false;
      vm.showCounter = false;
      vm.counterDown = 6;
      
      init();

      function showPrevMessage() {
        if (vm.currentMsgIndex > 0) {
          vm.currentMsgIndex--;
          vm.currentMsgNumber = vm.currentMsgIndex + 1;
          vm.currentMessage = messages[vm.currentMsgIndex].Description.replaceAll(/\n/g, "<br>");
          if (vm.isFirstMessageShown == true) 
            vm.isFirstMessageShown = false;
          if (vm.isLastMessageShown == true) 
            vm.isLastMessageShown = false;
        }
        if (vm.currentMsgIndex == 0 && vm.isFirstMessageShown == false) {
          vm.isFirstMessageShown = true;
        }
      }
  
      function showNextMessage() {
        if (vm.currentMsgIndex < messages.length - 1) {
          vm.currentMsgIndex++;
          vm.currentMsgNumber = vm.currentMsgIndex + 1;
          vm.currentMessage = messages[vm.currentMsgIndex].Description.replaceAll(/\n/g, "<br>");
          if (vm.isFirstMessageShown == true) 
            vm.isFirstMessageShown = false;
          if (vm.isLastMessageShown == true) 
            vm.isLastMessageShown = false;
        }
        if (vm.currentMsgIndex == messages.length - 1 && vm.isLastMessageShown == false) {
          vm.isLastMessageShown = true;
        }
      }
  
      function closeDialog() {
        $scope.closeThisDialog("close");
      }

      function init(){
        vm.isLastMessageShown  = messages.length == 1;

        if(vm.isLastMessageShown)
          counter(); 
      }

      function counter() {
        vm.showCounter = true;
        let count = vm.counterDown;
        let elementCounter = document.getElementById('showCounter');
        if (count == 0) {
            vm.showCounter = false;
            $timeout.cancel();
        } else {  
          if(elementCounter)
            elementCounter.innerText = count;
            
          vm.counterDown -= 1;
          $timeout(counter, 1000);
        }
      }
    }
  })();